module.exports = __webpack_public_path__ + "img/5edu.01d857bf.jpeg";